import api from "@/api/v1-jwt/config/api";

export const getSettings = async (userId) => {
  if (!userId) {
    throw new Error("[GET_SETTINGS] User ID missing.");
  }

  const { data } = await api.get(`/platform/settings/${userId}`);
  return data;
};

export const updateSettings = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[UPDATE_SETTINGS] User ID missing.");
  }

  const { data } = await api.patch(`/platform/settings/${userId}`, payload);

  return data;
};

export const uploadLogo = async ({ userId, file }) => {
  if (!userId) {
    throw new Error("[UPLOAD_LOGO] User ID missing.");
  }

  try {
    const formData = new FormData();
    formData.append("file", file, file.name);

    const { data } = await api.post(
      `/settings/files/${userId}/upload/settings`,
      formData,
      { headers: { "Content-Type": null } }
    );

    return { url: data.data };
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const uploadMarketingImage = async (file) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await api.post(
      `/settings/files/${clientCognitoId}/upload/client_settings`,
      formData,
      { headers: { "Content-Type": undefined } }
    );

    return { url: data.data };
  } catch (err) {
    console.error(err);
  }
};

export const jwtTest = async () => {
  const { data } = await api.get(`/jwt-test`);

  return data;
};
